import moment from 'moment'
import { localizedStrings } from '@core/strings'
import { statuses } from '@core/theme/statuses'
import { DocumentIntelligenceStatus } from '@core/entities/SiteBoxDocument/types'
import { Proof } from './types'

export type DocumentAppraisalInfo = {
  isSiteBox: boolean
  isAppraised: boolean
  status: DocumentIntelligenceStatus | undefined
  statusLabel: string | undefined
  statusColor: string
  reviewerName: string | undefined
  reviewedAt: string | undefined
}

export function getDocumentIntelligenceStatus(
  doc: Proof,
): DocumentIntelligenceStatus | undefined {
  return (doc.documentIntelligenceStatus ||
    doc.siteBoxDocument?.documentIntelligence?.status) as
    | DocumentIntelligenceStatus
    | undefined
}

export function isDocumentAppraised(doc: Proof): boolean {
  const status = getDocumentIntelligenceStatus(doc)
  return status === 'PASS' || status === 'FAIL'
}

export function getReviewerFullName(doc: Proof): string | undefined {
  if (doc.reviewedByName) return doc.reviewedByName
  const reviewer = doc.siteBoxDocument?.documentIntelligence?.reviewer
  if (!reviewer) return undefined
  return (
    [reviewer.firstName, reviewer.lastName].filter(Boolean).join(' ') ||
    undefined
  )
}

export function getReviewedAt(doc: Proof): string | undefined {
  if (doc.reviewedAt) return doc.reviewedAt
  const reviewDate = doc.siteBoxDocument?.documentIntelligence?.reviewDate
  return reviewDate ? moment(reviewDate).format('DD/MM/YYYY HH:mm') : undefined
}

export function getStatusLabel(doc: Proof): string | undefined {
  const status = getDocumentIntelligenceStatus(doc)
  switch (status) {
    case 'PASS':
      return localizedStrings.passed
    case 'FAIL':
      return localizedStrings.failed
    case 'IN_REVIEW':
      return localizedStrings.inReview
    case 'PROCESSING':
      return statuses.processing.label
    default:
      return undefined
  }
}
